import type { ReactNode } from 'react'
import { useEffect, useRef } from 'react'

import '@hotmart/cosmos/dist/sidebar'
import '@hotmart/cosmos/dist/sidebar/sidebar-header'
import '@hotmart/cosmos/dist/sidebar/sidebar-body'

import SidebarBody from '../sidebarBody'
import SidebarHeader from '../sidebarHeader'

export type SidebarElement = HTMLDivElement & {
  openSidebar: () => void
  closeSidebar: () => void
}

type SidebarProps = {
  children: ReactNode
  className?: string
  isOpen: boolean
  onClose?: () => void
}

const Sidebar = ({ children, isOpen, onClose, className }: SidebarProps) => {
  const ref = useRef<SidebarElement>(null)

  useEffect(() => {
    isOpen ? ref.current?.openSidebar() : ref.current?.closeSidebar()
  }, [isOpen])

  useEffect(() => {
    const current = ref.current

    onClose && current?.addEventListener('close', onClose)

    return () => onClose && current?.removeEventListener('close', onClose)
  }, [onClose])

  return (
    <hot-sidebar
      data-test='hot-sidebar-component'
      ref={ref}
      class={className}
      {...(isOpen && { open: true })}
      id='sidebar'>
      {children}
    </hot-sidebar>
  )
}

Sidebar.Header = SidebarHeader
Sidebar.Body = SidebarBody

export default Sidebar
